import { createServerFn } from '@tanstack/react-start'
import { env } from 'cloudflare:workers'
import { getDb } from '../db/client'
import { type PublicLog, getPublicLog } from '../db/queries'

export const getLogFn = createServerFn({ method: 'GET' })
  .inputValidator((id: string) => id)
  .handler(async ({ data: id }): Promise<PublicLog | null> => {
    if (!/^[0-9A-Za-z]{12}$/.test(id)) return null
    return getPublicLog(getDb(env.DB), id)
  })
